import service from '@/store/services/settings/district-type-service';

const state = {
    list: {},
    districtType: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, districtType) => {
        state.districtType = districtType;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(districtType => {
                commit('SET_RESOURCE', districtType);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(districtType => {
                commit('SET_RESOURCE', districtType);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((districtType) => {
                commit('SET_RESOURCE', districtType);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((districtType) => {
                commit('SET_RESOURCE', districtType);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    districtType: state => state.districtType,
    dropdown: (state) => {
        return state.list.map(districtType => ({
            id: districtType.id,
        }));
    }
};

const districtTypes = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default districtTypes;
